import { HTTPVerbs as a, ConsoleLogger as d, request as A } from "@nextgen-web-framework/core";
import { v5 as h } from "uuid";
function g(t) {
  return {
    url: `/comcontactas/${t}/contacts`,
    method: a.POST,
    retries: 0
  };
}
function l(t) {
  return {
    url: `/comcontactas/${t}/contacts`,
    method: a.GET,
    retries: 0
  };
}
function S(t, e) {
  return {
    url: `/comcontactas/${t}/contacts/${e}`,
    method: a.GET,
    retries: 0
  };
}
function f(t, e) {
  return {
    url: `/comcontactas/${t}/contacts/${e}`,
    method: a.PUT,
    retries: 0
  };
}
function E(t) {
  return {
    url: `/comaccountas/${t}/checkUser`,
    method: a.GET,
    retries: 0
  };
}
function P(t) {
  return {
    url: `/comprofileas/${t}/profiles`,
    method: a.GET,
    retries: 0
  };
}
function i(t) {
  return {
    url: `/comregistrationas/${t}/sponsors`,
    method: a.GET,
    retries: 0,
    timeout: 6e4
  };
}
function y(t) {
  return {
    url: `/comregistrationas/${t}/registrations`,
    method: a.GET,
    retries: 0
  };
}
function I(t) {
  return {
    url: `/comregistrationas/${t}/registrations`,
    method: a.POST,
    retries: 0
  };
}
function C(t) {
  return {
    url: `/comregistrationas/${t}/registrations`,
    method: a.PATCH,
    retries: 0,
    timeout: 6e4
  };
}
function L(t, e) {
  return {
    url: `/comregistrationas/${t}/registrations/${e}/submit`,
    method: a.POST,
    retries: 3,
    timeout: 6e4
  };
}
function p(t) {
  return {
    url: `/comcontactas/${t}/contact-search`,
    method: a.GET,
    retries: 0
  };
}
function N(t, e) {
  return {
    url: `/comprofileas/${t}/profiles/${e}/challenges`,
    method: a.POST,
    retries: 0
  };
}
function k(t, e) {
  return {
    url: `/comaccountas/${t}/accounts/${e}/challenges`,
    method: a.POST,
    retries: 0
  };
}
function w(t, e) {
  return {
    url: `/comaccountas/${t}/accounts/${e}/autoRenew`,
    method: a.GET,
    retries: 0
  };
}
function G(t) {
  return {
    url: `/comprofileas/${t}/profiles`,
    method: a.PATCH,
    retries: 0
  };
}
function D(t) {
  return {
    url: `/comblocksprivilegesas/${t}/tasks`,
    method: a.GET,
    retries: 0,
    timeout: 6e4
  };
}
function j(t, e) {
  return {
    url: `/comregistrationas/${t}/registrations/${e}/challenges`,
    method: a.POST,
    retries: 0,
    timeout: 6e4
  };
}
function R(t, e) {
  return {
    url: `/comcontactas/${t}/contacts/${e}`,
    method: a.DELETE,
    retries: 0
  };
}
function $(t, e) {
  return {
    url: `/comcontactas/${t}/${e}`,
    method: a.GET,
    retries: 0
  };
}
function T(t) {
  return {
    url: `/comcontractas/${t}/contracts`,
    method: a.GET,
    retries: 0
  };
}
function b(t) {
  return {
    url: `/comaccountas/${t}/accounts`,
    method: a.GET,
    retries: 0
  };
}
function O(t) {
  return {
    url: `/comaccountsearchas/${t}/search`,
    method: a.GET,
    retries: 0
  };
}
function v(t) {
  return {
    url: `/comprofilesubas/${t}/publications`,
    method: a.GET,
    retries: 0
  };
}
function U(t) {
  return {
    url: `/comprofilesubas/${t}/publications`,
    method: a.PATCH,
    retries: 0
  };
}
function B(t) {
  return {
    url: `/comaccountas/${t}/phones`,
    method: a.GET,
    retries: 0
  };
}
function H(t) {
  return {
    url: `/comaccountas/${t}/emails`,
    method: a.GET,
    retries: 0
  };
}
function q(t) {
  return {
    url: `/comaccountas/${t}/phones`,
    method: a.POST,
    retries: 0
  };
}
function V(t) {
  return {
    url: `/comaccountas/${t}/emails`,
    method: a.POST,
    retries: 0
  };
}
function x(t, e) {
  return {
    url: `/comaccountas/${t}/phones/${e}`,
    method: a.PATCH,
    retries: 0
  };
}
function F(t, e) {
  return {
    url: `/comaccountas/${t}/emails/${e}`,
    method: a.PATCH,
    retries: 0
  };
}
function K(t, e) {
  return {
    url: `/comaccountas/${t}/phones/${e}`,
    method: a.DELETE,
    retries: 0
  };
}
function M(t, e) {
  return {
    url: `/comaccountas/${t}/emails/${e}`,
    method: a.DELETE,
    retries: 0
  };
}
function Q(t) {
  return {
    url: `/compaymentas/${t}/payments`,
    method: a.POST,
    retries: 0
  };
}
const n = "v1", J = {
  createShippingDetails({ payload: t }, e) {
    const r = g(n);
    return t ? (r.body = t, s(r, e, !0)) : Promise.reject("Please check arguments");
  },
  getShippingAddressList({ contactType: t, ownerId: e, accountNumber: r }, o) {
    const c = l(n);
    return c.params = {
      contactType: t,
      ...e && { ownerId: e },
      ...r && { accountNumber: r }
    }, s(c, o);
  },
  putShippingAddressList({ payload: t, contactId: e }, r) {
    const o = f(n, e);
    return !e || !t ? Promise.reject("Please check arguments") : (o.body = t, s(o, r, !0));
  },
  checkUserExists({ username: t }) {
    const e = E(n);
    return t ? (e.params = {
      username: t
    }, s(e)) : Promise.reject("Please check arguments");
  },
  getProfiles(t) {
    const e = P(n);
    return s(e, t);
  },
  getDownlineAddressList({ contactType: t, ownerId: e, accountNumber: r }, o) {
    const c = l(n);
    return c.params = {
      contactType: t,
      ownerId: e,
      accountNumber: r
    }, s(c, o);
  },
  getSponsorByAccountNumber({ sponsorInputValue: t, accountType: e }, r) {
    const o = i(n);
    return !t || !e ? Promise.reject("Please check arguments") : (o.params = {
      regAccountType: e,
      accountNumber: t
    }, s(o, r));
  },
  getLeadsListByPostalCode({ sponsorInputValue: t, accountType: e }, r) {
    const o = i(n);
    return !t || !e ? Promise.reject("Please check arguments") : (o.params = {
      regAccountType: e,
      postalCd: t
    }, s(o, r));
  },
  getLeadsListWithoutPostalCode({ accountType: t, state: e, city: r }, o) {
    const c = i(n);
    if (!t)
      return Promise.reject("Please check arguments");
    const u = new URLSearchParams();
    return u.append("regAccountType", t), e && u.append("state", e), r && u.append("city", r), c.params = u, s(c, o);
  },
  getInternationalSponsor({
    sponsorInputValue: t,
    internationalSponsorAccountNumber: e,
    internationalSponsorCountryCode: r,
    accountType: o
  }, c) {
    const u = i(n);
    return !t || !o || !r || !e ? Promise.reject("Please check arguments") : (u.params = {
      regAccountType: o,
      accountNumber: t
    }, e && r && (u.params.internationalSponsorAccountNumber = e, u.params.internationalSponsorCountryCode = r), s(u, c));
  },
  createRegistrationId(t, e, r) {
    const o = I(n);
    return o.body = t, s(o, e, r);
  },
  getRegistration({ accountNumber: t, status: e, registrationFlow: r }, o) {
    const c = y(n), u = new URLSearchParams();
    return t && u.append("accountNumber", t.toString()), e && u.append("status", e), r && u.append("registrationFlow", r), c.params = u, s(c, o);
  },
  getRegistrationDetailsById(t, e, r) {
    const o = y(n);
    return o.url += `/${t}`, r && (o.params = {
      projection: r
    }), s(o, e);
  },
  async patchRegistration(t, e, r, o) {
    const c = C(n);
    return c.url += `/${e}`, r && (c.params = {
      stepName: r
    }), c.body = t, await s(c, o);
  },
  postSubmitRegistration(t, e, r) {
    const o = L(n, e);
    return e ? (o.body = t, s(o, r)) : Promise.reject("Please check arguments");
  },
  contactSearch(t, e) {
    const r = p(n);
    return r.params = {
      query: t
    }, s(r, e);
  },
  contactSearchContainer(t, e) {
    const r = p(n);
    return r.params = {
      containerId: t
    }, s(r, e);
  },
  contactSearchMatchId(t, e) {
    const r = p(n);
    return r.url += `/${t}`, s(r, e);
  },
  getProfilesById(t, e) {
    const r = P(n);
    return r.url += `/${t}`, s(r, e);
  },
  patchProfilesById({ payload: t, profileId: e }, r) {
    const o = G(n);
    return o.url += `/${e}`, o.body = t, s(o, r);
  },
  getProfileAddress({ ownerId: t, isDefault: e }, r) {
    const o = l(n);
    return o.params = {
      ownerId: t,
      isDefault: e ? "true" : "false"
    }, s(o, r);
  },
  postProfileAddress({ payload: t }, e) {
    const r = g(n);
    return r.body = t, s(r, e, !0);
  },
  putProfileAddress({ payload: t, contactId: e }, r) {
    const o = f(n, e);
    return !e || !t ? Promise.reject("Please check arguments") : (o.body = t, s(o, r, !0));
  },
  getAddressByContactId(t, e) {
    const r = S(n, t);
    return t ? s(r, e, !0) : Promise.reject("Please check arguments");
  },
  postProfileChallange({ payload: t, profileId: e }, r) {
    const o = N(n, e);
    return !e || !t ? Promise.reject("Please check arguments") : (o.body = t, s(o, r, !0));
  },
  postAccountChallenge({ payload: t, accountNum: e }, r) {
    const o = k(n, e);
    return !e || !t ? Promise.reject("Please check arguments") : (o.body = t, s(o, r, !0));
  },
  getTaskList(t, e, r, o) {
    const c = D(n);
    return c.params = {
      accountNumber: t
    }, e && (c.params.type = e), r && (c.params.status = r), s(c, o);
  },
  postRegistrationChallenge({ payload: t, registrationId: e }, r) {
    const o = j(n, e);
    return !e || !t ? Promise.reject("Please check arguments") : (o.body = t, s(o, r, !0));
  },
  deleteShippingAddressList(t, e) {
    const r = R(n, t);
    return t ? s(r, e) : Promise.reject("Please check arguments");
  },
  getContractList(t, e) {
    const r = T(n);
    return r.params = {
      accountNumber: t
    }, s(r, e);
  },
  getContractDetailList({ contractId: t, contractType: e, accountSubTypeCd: r, seqNo: o, locale: c }, u) {
    const m = T(n);
    return m.url += `/${t}`, m.params = {
      accountSubTypeCd: r,
      contractType: e,
      seqNo: String(o),
      ...c && { language: c }
    }, s(m, u);
  },
  getAddressRegionData(t, e, r) {
    const o = $(n, t);
    return o.params = {
      language: e
    }, s(o, r);
  },
  getAddressRegionSearch(t, e, r) {
    const o = $(n, t);
    return o.params = {
      ...e
    }, s(o, r);
  },
  getAccountByNum(t, e, r) {
    const o = b(n);
    return o.url += `/${t}/mappings`, e !== void 0 && (o.params = {
      isPrimary: e ? "true" : "false"
    }), s(o, r);
  },
  getAccountInformation(t, e) {
    const r = b(n);
    return r.url += `/${t}`, s(r, e);
  },
  getAccountAutoRenewal(t, e) {
    const r = w(n, t);
    return s(r, e);
  },
  getPublication(t, e, r) {
    const o = v(n);
    return o.params = {
      accountNumber: t,
      profileId: e
    }, s(o, r);
  },
  patchPublication(t, e, r, o) {
    const c = U(n);
    return c.params = {
      accountNumber: t,
      profileId: e
    }, c.body = r, s(c, o);
  },
  getAccountPhones(t, e, r = !0, o = !1, c) {
    try {
      const u = B(n);
      return u.params = {
        accountNumber: t,
        profileId: e,
        ...r && { isDefault: "true" },
        // For alternative phone numbers, isDefault is not required
        isDeleted: String(o)
      }, s(u, c);
    } catch (u) {
      return d.error(u), Promise.resolve({ phoneList: [] });
    }
  },
  getAccountEmails(t, e, r = !0, o = !1, c) {
    try {
      const u = H(n);
      return u.params = {
        accountNumber: t,
        profileId: e,
        isDefault: String(r),
        isDeleted: String(o)
      }, s(u, c);
    } catch (u) {
      return d.error(u), Promise.resolve({ emailList: [] });
    }
  },
  postAccountPhone(t, e) {
    const r = q(n);
    return r.body = t, s(r, e);
  },
  postAccountEmail(t, e) {
    const r = V(n);
    return r.body = t, s(r, e);
  },
  patchAccountPhone(t, e, r) {
    const o = x(n, t);
    return o.body = e, s(o, r);
  },
  patchAccountEmail(t, e, r) {
    const o = F(n, t);
    return o.body = e, s(o, r);
  },
  deleteAccountPhone(t, e) {
    const r = K(n, t);
    return s(r, e);
  },
  deleteAccountEmail(t, e) {
    const r = M(n, t);
    return s(r, e);
  },
  /**
   * @deprecated This is not a profile API endpoint and will be removed in future versions once it's added to registration api.
   */
  postPayment(t, e) {
    const r = Q(n);
    return r.body = t, s(r, e);
  },
  getAccountDetails(t, e) {
    const r = O(n);
    return r.params = t.params, s(r, e);
  }
};
async function s(t, e, r) {
  try {
    e != null && e.headers && (t.headers = e == null ? void 0 : e.headers), e != null && e.baseURL && (t.url = `${e.baseURL}${t.url}`);
    const o = await A(t, r ? {
      skipIdempotency: !1,
      customCache: !0,
      customKeyGenerator: () => h(`${Date.now()}`, h.URL)
    } : {});
    return Promise.resolve(o);
  } catch (o) {
    throw d.error(o), o;
  }
}
export {
  J as Q
};
//# sourceMappingURL=profileApi-04b19141.mjs.map
